export const iconFontAwesomeMoneyEuroSign = (
	<i className="fa-solid fa-euro-sign"></i>
);
